import { render, staticRenderFns } from "./CsTarifariosTarifasTrabajo.vue?vue&type=template&id=6b5fd999"
import script from "./CsTarifariosTarifasTrabajo.vue?vue&type=script&lang=js"
export * from "./CsTarifariosTarifasTrabajo.vue?vue&type=script&lang=js"
import style0 from "./CsTarifariosTarifasTrabajo.vue?vue&type=style&index=0&id=6b5fd999&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports